import React, { useEffect } from 'react';
import { useFeatureFlags, useIsSignAndSend } from '../../hooks';
import { CanvasCustomControlsProps } from './canvas-custom-config-types';
import { setCustomControls } from './utils/set-custom-controls';
import { useAppContext } from '../../context/app-context';
import { useInitializationDataContext } from '../../context/data-context';
import { setCustomCroppingControls } from './utils/set-custom-crop-controls';
import { patchClipPathRendering } from './utils/patch-clip-path-rendering';
import {
  deleteIcon,
  rotateIcon,
  scaleIcon,
  circleIcon,
  rectangleIcon,
} from '../../components/canvas-custom-config/utils/fabric-icons';

export const CanvasCustomConfig = ({ children }: CanvasCustomControlsProps) => {
  const { appDispatch } = useAppContext();
  const windowFabric = window.fabric;
  const isSignAndSend = useIsSignAndSend();
  const { IS_NEW_IMAGE_EDIT_TOOLBAR_ENABLED } = useFeatureFlags();
  const {
    initializedDataState: { isUK },
  } = useInitializationDataContext();

  /**
   * Sets specific properties of fabric instance overriding its defaults
   *
   * @param {Object} _fabric fabric instance
   */
  const setFabricConfiguration = ({ _fabric }: any) => {
    _fabric.disableStyleCopyPaste = true;
    patchClipPathRendering(_fabric);
  };

  useEffect(() => {
    const fabricObj = {
      _fabric: windowFabric,
    };
    setCustomControls(
      fabricObj,
      { deleteIcon, rotateIcon, scaleIcon, circleIcon, rectangleIcon },
      appDispatch,
      isUK,
      IS_NEW_IMAGE_EDIT_TOOLBAR_ENABLED,
    );
    setFabricConfiguration(fabricObj);
  }, [windowFabric, IS_NEW_IMAGE_EDIT_TOOLBAR_ENABLED]);

  useEffect(() => {
    if (windowFabric && (isSignAndSend || IS_NEW_IMAGE_EDIT_TOOLBAR_ENABLED)) {
      const fabricObj = {
        _fabric: windowFabric,
      };

      setCustomCroppingControls(fabricObj, IS_NEW_IMAGE_EDIT_TOOLBAR_ENABLED);
    }
  }, [isSignAndSend, windowFabric, IS_NEW_IMAGE_EDIT_TOOLBAR_ENABLED]);

  return <>{children}</>;
};
